/**
 * Validate before exporting data
 * @param {*} e Event object
 * @param {*} options Validation options 
 * @returns 
 */
export function validateBeforeExport(e, options = {}) {
    const ds = e.component.getDataSource && e.component.getDataSource();
    const total = ds && typeof ds.totalCount === 'function' ? ds.totalCount() : (ds && ds.total) || 0;


    if (total == 0) {
        e.cancel = true;
        if (options.validationSummary) {
            options.validationSummary([{ message: 'There is no data to download. Please generate report data by selecting your report criteria and applying them.' }]);
        }
        return false;
    }


    if (total > (options.maxExportRows || 30000)) {
        e.cancel = true;
        if (options.validationSummary) {
            options.validationSummary([{ message: 'Export is too large, please filter the list and try exporting again.' }]);
        }
        return false;
    }


    return true;
}